import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mc-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit {

  constructor() { }

  isOpened = false;

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/template/sidebar/sidebar.component.ts